import React, { useEffect } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import RouterLinkButton from "components/buttons/RouterLinkButton";
import PageSection from "components/layout/PageSection";
import Spacer from "components/Spacer";
import DefaultAosAnimation from "components/aos/DefaultAosAnimation";
import routes from "routes";
import WhiteTextBoxWithAdornments, {
    WhiteTextBoxWithAdornmentsIcons,
} from "components/textBoxes/whiteTextBox/WhiteTextBoxWithAdornments";
import ErrorCodeComponent from "./ErrorCodeComponent";
import Scribble from "components/scribble/Scribble";
import RandomRotate from "components/rotate/RandomRotate";
import useBackgroundStyles from "components/backgrounds/useBackgroundStyles";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            minHeight: "50vh",
        },
        errorCodeContainer: {
            marginLeft: 40,
        },
        errorCode: {
            maxWidth: 250,
        },
        iconContainer: {
            marginRight: 15,
        },
        title: {},
        text: {},
        homeButtonContainer: {
            position: "absolute",
            width: "100%",
            left: 0,
            display: "flex",
            justifyContent: "center",
        },
        scribbleContainer: {
            top: "5%",
            left: "-10%",
            height: "130%",
            width: "90%",
        },
    });
});

interface IProps {
    errorCode: number;
    title: string;
    text?: string;
}

export default function ErrorPage(props: IProps) {
    const { errorCode, title, text } = props;
    const classes = useStyles();
    const backgrounds = useBackgroundStyles();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <PageSection
            skewed
            className={classes.root}
            classes={{ skewedSectionRoot: backgrounds.default }}
        >
            <div
                style={{
                    flex: "1",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <DefaultAosAnimation order={2}>
                    <RandomRotate min={1.5} max={2}>
                        <Scribble
                            variant="v3"
                            classes={{
                                scribbleContainer: classes.scribbleContainer,
                            }}
                        >
                            <WhiteTextBoxWithAdornments
                                titlePrefixComponent={
                                    <div className={classes.errorCode}>
                                        <ErrorCodeComponent errorCode={errorCode} />
                                    </div>
                                }
                                icon={WhiteTextBoxWithAdornmentsIcons.WARNING}
                                classes={{
                                    title: classes.errorCodeContainer,
                                    icon: classes.iconContainer,
                                }}
                            >
                                <Spacer size={1} />
                                <Grid container direction="column">
                                    <Grid item>
                                        <Typography variant="body1" className={classes.title}>
                                            {title}
                                        </Typography>
                                    </Grid>

                                    {typeof text === "undefined" ? null : (
                                        <>
                                            <Spacer />
                                            <Grid item>
                                                <Typography
                                                    variant="body1"
                                                    className={classes.text}
                                                >
                                                    {text}
                                                </Typography>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                                <Spacer size={3} />
                                <div className={classes.homeButtonContainer}>
                                    <RouterLinkButton to={routes.home.route}>
                                        Home Page
                                    </RouterLinkButton>
                                </div>
                            </WhiteTextBoxWithAdornments>
                        </Scribble>
                    </RandomRotate>
                </DefaultAosAnimation>
                <Spacer size={4} />
            </div>
        </PageSection>
    );
}
